export var VideoActionTypes;
(function (VideoActionTypes) {
    VideoActionTypes["FETCH_VIDEOS_ATTEMPT"] = "FETCH_VIDEOS_ATTEMPT";
    VideoActionTypes["FETCH_VIDEOS_SUCCESS"] = "FETCH_VIDEOS_SUCCESS";
    VideoActionTypes["FETCH_VIDEOS_FAILURE"] = "FETCH_VIDEOS_FAILURE";
})(VideoActionTypes || (VideoActionTypes = {}));
